import { render, staticRenderFns } from "./max-width.vue?vue&type=template&id=b42ab902&"
import script from "./max-width.vue?vue&type=script&lang=js&"
export * from "./max-width.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports